'use client'
import React, { ReactNode, useEffect, useRef, useState } from "react";

import {HeroTextContent, HeroTextSectionContainer, HeroText} from "./styles";
import { H1 } from "../../components/Typography";
import {getImage, getImageProp, ImageProps, FULL_WIDTH} from "@itchannelplus/utils";
import {StaticImport} from "next/dist/shared/lib/get-img-props";
import Image from "next/image";
import {ExpandButton} from "../../components/buttons/ExpandButton";
import {ButtonLink} from "../../components/buttons/Button";
import {ScrollToButtonLink} from "../../components/buttons/ScrollToButton";
import {IRootItem} from "../../components/BreadCrumb/types";
import {BreadCrumb} from "../../components/BreadCrumb";
import styles from "./styles.module.scss";

import {useCollapse} from "react-collapsed";
import nl2br from "react-br";

export interface HeroCtaButton {
  label: string;
  href?: string;
  scrollTo?: string;
  color?: "dark" | "light" | "primary" | "secondary";
  variant?: "solid" | "outline";
  target?: string;
}

export type HeroTextSectionProps = {
    title:string;
    tagline?:string|ReactNode;
    text?:string|ReactNode;
    textCenter?:boolean;
    readMore?:string;
    bgImage?:string|StaticImport|ImageProps;
    gradient?:boolean;
    expandable?: boolean;
    breadcrumb?: IRootItem[];
    noPaddingTop?:boolean;
    titleSize?: 'big' | 'medium' | 'small' | 'xsmall';
    ctaButtons?: HeroCtaButton[];
    ctas?: HeroCtaButton[];
    children?: ReactNode;
  [key: string]: any;
}

export const HeroTextSection = ({title, text, bgImage, tagline, textCenter = true, gradient = false, expandable = false, breadcrumb, readMore, noPaddingTop = false, titleSize, ctaButtons, ctas, children, ...props}: HeroTextSectionProps) => {
    const [isExpandable, setExpandable] = useState(expandable);
    const [collapseHeight, setCollapseHeight] = useState(300);
    const collapseRef = useRef<HTMLDivElement>(null);
    const textRef = useRef<HTMLDivElement>(null);
    const buttons = ctaButtons || ctas;
    //const t = useTranslations();
  useEffect(() => {
    //we calculate the height of the text content
    if (textRef.current) {
      const h = textRef.current.getBoundingClientRect()?.height || textRef.current.scrollHeight || textRef.current.offsetHeight;
      const maxHeight = window.innerHeight * 0.3;
      console.log('textRef height',  h, maxHeight);
      setExpandable(expandable && h - maxHeight > 20  )
      setCollapseHeight( h - maxHeight > 20 ? maxHeight : h );
    }
  }, [textRef, expandable]);
  const { getCollapseProps, getToggleProps, isExpanded, setExpanded } =
    useCollapse({
      defaultExpanded: !isExpandable,
      //isExpanded: !isExpandable,
      collapsedHeight: collapseHeight,
      //easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      //duration: number,
      //onTransitionStateChange: func,
    });
    const longTitle = title.length > 40;
    const h1Size = titleSize || (longTitle ? 'medium' : 'big');
    return <HeroTextSectionContainer {...{gradient}} bgImage={!!bgImage} {...props} expanded={isExpanded} noPaddingTop={noPaddingTop} >
      {bgImage && <Image src={getImage( bgImage )} alt={getImageProp('alt', bgImage ) || title} fill sizes={FULL_WIDTH} />}
      <HeroTextContent >
        <H1  center size={h1Size}>
          {tagline && <small className={"tagline"}>{tagline}</small>}
          {nl2br(title)}
        </H1>
        {!!breadcrumb?.length && <BreadCrumb items={breadcrumb} small center  /> }
        {!!text && typeof  text == 'string' && <HeroText center={textCenter} lineHeight={"medium"} light {...getCollapseProps({ref:collapseRef})} ><div dangerouslySetInnerHTML={{__html: text}} ref={textRef}></div></HeroText>}
        {!!text && typeof  text != 'string' && <HeroText center={textCenter} lineHeight={"medium"} light {...getCollapseProps({ref:collapseRef})} ><div ref={textRef}>{text}</div></HeroText>}
        { isExpandable && !isExpanded  && !!text && <ExpandButton {...getToggleProps()} className={'center flex'}>{readMore}</ExpandButton>}
        {!!buttons?.length && (
          <div className={styles.ctas}>
            {buttons.map((btn, idx) => {
              if (btn.scrollTo) {
                const { label, scrollTo: _scrollTo, ...btnRest } = btn;
                return (
                  <ScrollToButtonLink
                    key={idx}
                    scrollTo={_scrollTo}
                    href={btnRest.href || '#'}
                    color={btnRest.color || (idx === 0 ? "dark" : "light")}
                    variant={btnRest.variant || (idx === 0 ? "solid" : "outline")}
                    size={"normal"}
                    {...btnRest}
                  >
                    {label}
                  </ScrollToButtonLink>
                );
              }
              const { label, ...btnRest } = btn;
              return (
                <ButtonLink
                  key={idx}
                  href={btnRest.href || "#"}
                  color={btnRest.color || (idx === 0 ? "dark" : "dark")}
                  variant={btnRest.variant || (idx === 0 ? "solid" : "outline")}
                  size={"normal"}
                  target={btnRest.target}
                  {...btnRest}
                >
                  {label}
                </ButtonLink>
              );
            })}
          </div>
        )}
        {children}
      </HeroTextContent>
    </HeroTextSectionContainer>

};

export default HeroTextSection;
